module.exports = __webpack_public_path__ + "images/aa-migration-wizard/illustration-email.f5bfd1f807d345c61e4c.svg";